// extracted by mini-css-extract-plugin
export default {"intro":"Projects_intro__jEtXI","container":"Projects_container__HexWw","note":"Projects_note__PEi65"};